/**
 * The public (unauthenticated) site: landing page, about/how-to-use guide,
 * security, roadmap. Reachable with or without a session; the shell picks
 * which footer to render based on this.
 */
export const PUBLIC_SITE_PATHS = ["/", "/about", "/security", "/security/technical", "/roadmap"];

export function isPublicSitePath(pathname: string): boolean {
  return PUBLIC_SITE_PATHS.includes(pathname.replace(/\/+$/, "") || "/");
}
